/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import React from 'react'

import { getSmartSize } from '../../utils/helpers/styles'
import { useBackgroundStyle } from '../../utils/styles/background'
import { useBorderStyle } from '../../utils/styles/border'
import { useGridStyle } from '../../utils/styles/grid'
import { useMarginStyle } from '../../utils/styles/margin'
import { usePaddingStyle } from '../../utils/styles/padding'
import { useSizeStyle } from '../../utils/styles/size'
import ConditionalLink from '../actions/ConditionalLink'

const Separator = ({ size, vertical, weight, children, usePadding, ...props }) => {
  if (weight) size = weight * 0.25
  const sizeValue = getSmartSize(size, {}, 0.25)
  const key = usePadding ? 'padding' : 'margin'

  const style = css`
    ${key}-${!vertical ? 'bottom' : 'left'}: ${sizeValue};
    ${useSizeStyle(props)}
    ${useMarginStyle(props)}
  `

  if (!!children) {
    return (
      <SeparatorWrapper weight={weight} size={size} usePadding={usePadding} {...props}>
        {children}
      </SeparatorWrapper>
    )
  }

  return <div className="separator" css={style} {...props} />
}

const SeparatorWrapper = ({ size, weight, usePadding, children, ...props }) => {
  if (weight) size = weight * 0.25
  const padding = usePadding ? size : undefined
  const margin = !usePadding ? size : undefined

  const style = css`
    ${useGridStyle(props)}
    ${useBackgroundStyle(props)}
    ${useBorderStyle(props)}
    ${usePaddingStyle({ padding, ...props })}
    ${useMarginStyle({ margin, ...props })}
  `

  return (
    <ConditionalLink block {...props}>
      <div className="separator separatorWrapper" css={style} {...props}>
        {children}
      </div>
    </ConditionalLink>
  )
}

export default Separator
